// @ts-ignore

import { Injectable } from '@angular/core';
import swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor() { }

  async confirmation(
    title,
    message,
    confirmButtonText = 'Continuar',
  ) {
    // @ts-ignore
    return swal.fire({
      title,
      text: message,
      confirmButtonColor: '#fff',
      background: '#eeedf2',
      customClass: {
        confirmButton: 'btn button-precas',
        cancelButton: 'btn button-precas ml-3',
        input: 'inputswt',
        title: 'titleswt'
      },
      showCloseButton: false,
      showCancelButton: true,
      allowOutsideClick: false,
      buttonsStyling: false,
      heightAuto: false,
      confirmButtonText,
      cancelButtonText: 'Cancelar',
    });
  }

  async confirmationHMTL(
    title,
    message,
    confirmButtonText = 'Continuar',
    cancelButtonText = 'Finalizar',
  ) {
    // @ts-ignore
    return swal.fire({
      title,
      html: message,
      confirmButtonColor: '#fff',
      background: '#eeedf2',
      customClass: {
        confirmButton: 'btn button-precas',
        cancelButton: 'btn button-precas ml-3',
        input: 'inputswt',
        title: 'titleswt'
      },
      showCloseButton: false,
      showCancelButton: true,
      allowOutsideClick: false,
      buttonsStyling: false,
      heightAuto: false,
      confirmButtonText,
      cancelButtonText,
    });
  }

  show(title, message) {
    return swal.fire({
      title,
      html: message,
      confirmButtonColor: '#fff',
      allowOutsideClick: false,
      background: '#eeedf2',
      customClass: {
        confirmButton: 'btn button-precas',
        input: 'inputswt',
        title: 'titleswt'
      },
      showCloseButton: true,
      buttonsStyling: false,
      heightAuto: false,
      confirmButtonText: 'Continuar'
    });
  }
}
